import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { fetchvuuklegetCommentCount } from "../../../../../../api";

class VuukleCommentCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: {}
    };
  }

  componentDidMount() {
    const storyId = get(this.props, ["storyId"], () => null);
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        this.setState({ count: res.data });
      })
      .catch(console.error);
  }

  render() {
    const { storyId, className, mobileView } = this.props;
    const count = get(this.state, ["count", storyId], 0);
    let view = <span className={className}>{count === 0 ? `Comment` : `${count} Comment`}</span>;
    if (mobileView) {
      view = (
        <span style={{ fontSize: "15px", paddingLeft: "2px", color: "#ffffff" }} className={className}>
          {count === 0 ? ` ` : `${count}`}
        </span>
      );
    }
    return view;
  }
}

VuukleCommentCount.propTypes = {
  storyId: PropTypes.string,
  className: PropTypes.string,
  mobileView: PropTypes.string
};

export default VuukleCommentCount;
